var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFaqs11(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 62,
    r: 61,
    stroke: "#339999",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.1721 81.1966C58.0801 83.6832 63.726 84.3567 69.0923 83.0958C74.4586 81.8348 79.1925 78.7224 82.4409 74.3192C85.6892 69.9161 87.2385 64.5119 86.8095 59.0804C86.3805 53.6489 84.0014 48.5474 80.1009 44.695C76.2004 40.8427 71.0351 38.493 65.5357 38.0693C60.0363 37.6455 54.5646 39.1757 50.1064 42.384C45.6482 45.5922 42.4968 50.2677 41.2202 55.5677C39.9435 60.8678 40.6254 66.4439 43.1431 71.2913L38 86.2762L53.1721 81.1966Z",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4872 53.7667C72.2855 52.6033 70.6698 51.9517 68.987 51.9517C67.3043 51.9517 65.6886 52.6033 64.4868 53.7667L63.7154 54.7826L62.8153 54.0207C62.2258 53.3905 61.5092 52.8892 60.7116 52.549C59.9141 52.2088 59.0533 52.0373 58.1846 52.0456C57.3159 52.0538 56.4586 52.2416 55.6678 52.5969C54.877 52.9521 54.1703 53.4669 53.5931 54.1082C53.016 54.7495 52.5812 55.503 52.3167 56.3203C52.0522 57.1376 51.9639 58.0005 52.0574 58.8535C52.151 59.7065 52.4243 60.5308 52.8599 61.2732C53.2954 62.0155 53.8836 62.6596 54.5864 63.164L63.8439 72.0533L73.1015 63.164C76.1874 60.1162 75.9302 56.3065 73.6158 53.7667",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFaqs11);
export default __webpack_public_path__ + "static/media/IconFaqs11.5ceec329317b9dc2e7a4fe34f5d4667c.svg";
export { ForwardRef as ReactComponent };